module.exports = __webpack_public_path__ + "static/media/Brad Sapienza Headshot_1674558734516.704c2c7a.png";